export const userLoggedIn = function () {
  const bodyClasses = document.body.classList
  return typeof bodyClasses !== 'undefined' && bodyClasses.contains('logged-in')
}

export const isIOS = /^(?![\w\W]*Windows Phone)[\w\W]*(iPhone|iPad|iPod)/i.test(navigator.userAgent)

export const isProduction = (window.location.hostname.indexOf('com.au') > -1)



// WEBPACK FOOTER //
// ./sportspower/assets/es6/helpers.js